<script setup>
import VDevider from "@/Shared/VDevider.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VInputReadonlyWithBlockLabel from "../../Form/Survey/VInputReadonlyWithBlockLabel.vue";

import { useForm } from "@inertiajs/vue3";

const props = defineProps({
    additional: Object,
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    which_of_the_following_entry_point_did_you_go_through_to_enter_sabah:
        answers?.which_of_the_following_entry_point_did_you_go_through_to_enter_sabah,
});

const emits = defineEmits("onNext");

const handleClickNext = () => {
    emits("onNext", form.data());
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <VInputReadonlyWithBlockLabel
                        elId="which_of_the_following_entry_point_did_you_go_through_to_enter_sabah"
                        v-model:value="
                            form.which_of_the_following_entry_point_did_you_go_through_to_enter_sabah
                        "
                        :label="
                            surveyFields[
                                'which_of_the_following_entry_point_did_you_go_through_to_enter_sabah'
                            ]?.name
                        "
                        :isPlainText="false"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
